import { render, staticRenderFns } from "./CourseRecordListView.vue?vue&type=template&id=0f6915cf&scoped=true"
import script from "./CourseRecordListView.vue?vue&type=script&lang=js"
export * from "./CourseRecordListView.vue?vue&type=script&lang=js"
import style0 from "./CourseRecordListView.vue?vue&type=style&index=0&id=0f6915cf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6915cf",
  null
  
)

export default component.exports